import React from 'react';
import { CardHeader, Flex, IconButton, IconReload } from '@zillow/constellation';

export const TableCardHeader: React.FC<{ refetch: () => void; children?: React.ReactNode; title: string }> = ({
  refetch,
  children,
  title,
}) => {
  return (
    <CardHeader>
      <Flex display={'flex'} flexDirection={'row'} gap={'sm'} justifyContent={'space-between'}>
        <Flex display={'flex'} flexDirection={'row'} gap={'xs'} alignItems={'center'}>
          <IconButton icon={<IconReload />} onClick={refetch} title={'Refresh the table'} size={'sm'} />
          {title}
        </Flex>
        {children}
      </Flex>
    </CardHeader>
  );
};
